import { useEffect } from "react";
import { useNavigate } from "react-router-dom";

const FailedPayment = ({ status, message }) => {
  const navigate = useNavigate();


  return (
    <div className="d-flex flex-column align-items-center justify-content-center vh-100 text-center">
      <i className="bi bi-x-circle text-danger display-1"></i>
      <h1 className="mt-4 fw-bold">Payment {status}!</h1>
      <p className="text-muted mt-2">{message}</p>
      <button className="btn btn-danger mt-4" onClick={() => navigate("/book-room/1")}>Try Again</button>
    </div>
  );
};

export default FailedPayment;